<template>
  <a
    v-if="isLink && linkTo"
    :href="linkTo"
    :humblytics="'taxonomy-' + type + '-link'"
    @click.prevent="navigate"
    :class="pillClasses"
  >
    {{ displayName }}
  </a>
  <span v-else :class="pillClasses">
    {{ displayName }}
  </span>
</template>

<script>
import { getTaxonomySlugSync, preloadTaxonomies } from '@/utils/taxonomySlugLookup.js';

export default {
  name: 'TaxonomyPill',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['concept', 'format', 'topic', 'author'].includes(value)
    },
    name: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: null
    }
  },
  created() {
    preloadTaxonomies();
  },
  computed: {
    isLink() {
      return this.type !== 'author';
    },
    linkTo() {
      if (!this.isLink) return null;
      
      const taxonomyTypeMap = {
        concept: 'concepts',
        format: 'formats',
        topic: 'topics'
      };
      
      const taxonomyType = taxonomyTypeMap[this.type];
      if (!taxonomyType) return null;
      
      const slug = getTaxonomySlugSync(taxonomyType, this.name);
      
      const routes = {
        concept: `/concepts/${slug}`,
        format: `/formats/${slug}`,
        topic: `/topics/${slug}`
      };
      
      return routes[this.type] || null;
    },
    displayName() {
      return this.name;
    },
    pillClasses() {
      const baseClasses = 'inline-flex items-center px-3 py-2 sm:px-2 sm:py-1 rounded-full text-xs font-medium transition-colors border cursor-pointer';
      
      const typeClasses = {
        concept: 'border-green-500 text-green-800 bg-transparent hover:bg-green-50',
        format: 'border-blue-500 text-blue-800 bg-transparent hover:bg-blue-50',
        topic: 'border-purple-500 text-purple-800 bg-transparent hover:bg-purple-50',
        author: 'border-gray-500 text-gray-800 bg-transparent cursor-default'
      };
      
      return `${baseClasses} ${typeClasses[this.type]}`;
    }
  },
  methods: {
    navigate() {
      if (this.linkTo) {
        this.$router.push(this.linkTo);
      }
    }
  }
};
</script>
